export enum TicketStatus {
  PaymentPending = 'PaymentPending',
  PaymentConfirmed = 'PaymentConfirmed',
  Unconfirmed = 'Unconfirmed'
}